const Values = () => {
  const values = ["الشفافية", "التمكين", "المسؤولية", "العدالة", "العطاء"];

  return (
    <article>
      <h2 className="text-[#408099] font-bold text-md md:text-lg lg:text-2xl mb-2 md:mb-4">
        القيم
      </h2>
      <ul>
        {values.map((element) => (
          <li className="list-disc mr-8" key={element}>
            {element}
          </li>
        ))}
      </ul>
    </article>
  );
};
export default Values;
